import React from "react";
import { ApiResult } from "../../lib/CmsApi";
import MagazineDetailPage from "./MagazineDetailPage";

export type Props = ApiResult<"loadMagazinNewsBySlug"> & {
  relatedNews: ApiResult<"listMagazinNews">;
};
export default function NewsDetailPage({relatedNews, ...props}: Props) {
  return (
    <>
      <MagazineDetailPage
        content={props}
        breadCrumpPath={[
          {
            route: "news",
            title: "News"
          },
          {
            route: "newsArticle",
            title: props.title,
            params: { slug: props.slug }
          }
        ]}
        relatedNews={relatedNews}
      />
    </>
  );
}

NewsDetailPage.getImages = (props: Props) => {
  let images = MagazineDetailPage.getImages({ content: props });
  images = images.concat(
    props.relatedNews.items.map(n => n.headerImage).filter(Boolean)
  );
  return images;
};
